__webpack_require__.p = "https://bmidxbpolandplpreprod.netlify.app/";